var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.333 14.067v-4.74c0-.855 0-1.282-.109-1.676a3 3 0 0 0-.47-.969c-.241-.33-.576-.594-1.246-1.123l-1.534-1.21c-1.062-.84-1.594-1.26-2.181-1.42a3 3 0 0 0-1.585 0c-.588.16-1.12.58-2.182 1.42l-1.534 1.21c-.67.529-1.005.793-1.246 1.123a3 3 0 0 0-.47.97c-.11.393-.11.82-.11 1.674v4.74c0 .56 0 .84.11 1.055a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109H6.4c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436C8 14.907 8 14.627 8 14.067v-1.734a2 2 0 1 1 4 0v1.734c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h1.133c.56 0 .84 0 1.054-.11a1 1 0 0 0 .437-.436c.11-.214.11-.494.11-1.054z"
})));
SvgHome.displayName = "SvgHome";
export { SvgHome as ReactComponent };
export default SvgHome;